<template>
  <portal :to="value ? 'popup' : ''">
    <div class="layout-popup abs">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
        <div v-if="opened" @click="close" class="overlay abs"></div>
      </transition>
      <transition enter-active-class="animated zoomIn" leave-active-class="animated zoomOut">
        <div v-if="opened" class="window ui-scroll" :class="[{ smallPadding }]">
          <ui-popup-form v-if="!sended">
            <slot></slot>
            <div class="form-content">
              <slot name="form"></slot>
            </div>
            <slot name="suffix"></slot>
          </ui-popup-form>
          <div class="success" v-else>
            <icon-success class="animated zoomIn"></icon-success>
            <div class="s-30 w-500">Заявка отправлена</div>
            <div v-if="subText" class="s-16">Ожидайте, когда менеджер с вами свяжется</div>
            <ui-button @click="close">Закрыть окно</ui-button>
          </div>
          <div @click="close" class="close-button"><icon-close></icon-close></div>
        </div>
      </transition>
    </div>
  </portal>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      required: true
    },
    smallPadding: {
      type: Boolean,
      default: false
    },
    sended: {
      type: Boolean,
      default: false
    },
    subText: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      localOpened: false
    }
  },
  watch: {
    value: {
      handler() {
        this.value && (this.localOpened = true)
      },
      immediate: true
    }
  },
  computed: {
    opened() {
      return this.value && this.localOpened
    }
  },
  components: {
    'icon-close': () => import('@/components/icon/icon-close'),
    'icon-success': () => import('@/components/icon/icon-success'),
    'ui-popup-form': () => import('@/components/ui/ui-popup-form'),
    'ui-button': () => import('@/components/ui/ui-button')
  },
  methods: {
    close() {
      this.localOpened = false;
      this.$bus.$emit('updateSended');
      setTimeout(() => {
        this.$emit('input', false)
      }, 300)
    }
  }
}
</script>

<style lang="scss" scoped>
.layout-popup {
  position: fixed;
  z-index: 500;
  pointer-events: none;
  display: flex;
  & > * {
    pointer-events: all;
  }
}
.overlay {
  background: rgba(50, 59, 83, 0.8);
}
.window {
  margin: auto;
  width: 500px;
  max-width: 100%;
  padding: 3em 5em;
  background: #fff;
  position: relative;
  border-radius: 10px;
  z-index: 10;
  text-align: center;
  max-height: 80vh;
  &.smallPadding {
    padding: 2em;
  }
}
.close-button {
  position: absolute;
  right: 2em;
  top: 2em;
  cursor: pointer;
}
.success {
  svg {
    margin-bottom: 2em;
  }
  .ui-button {
    margin-top: 4em;
  }
}
@media screen and (max-width: 767px) {
  .window {
    padding: 1em;
    margin: auto 15px;
    &.smallPadding {
      padding: 1em;
    }
  }
}
</style>

<style lang="scss">
.layout-popup {
  .form-content {
    margin: 0.5em 0;
    & > * {
      margin-bottom: 10px;
    }
  }
}
</style>